<div class="box">
  <div class="ribbon ribbon-top-left" *ngIf="ribbonEnv">
    <span>{{ ribbonEnv }}</span>
  </div>
</div>
